import React from "react";

const Usage = () => {
  return (
    <section id="usage">
      <div className="dbline"></div>
      <div className="subheading">
        🚀 Submit a Usage Example (Show Us How It's Done!)
      </div>
      Method : <span className="method">POST</span>
      <br />
      Endpoint:
      <span className="method">POST /pickup-lines/usage-example/:id</span>
      <div className="dbline"></div>
      Description:
      <br /> Feeling creative? Share a usage example for a pickup line and show
      the world how it's done! 🎭
      <div className="dbline"></div>
      Request Body:
      <br />
      <div className="idea">
        -`example` (string, required) - Your awesome usage example.
      </div>
      <div className="dbline"></div>
      Responses:
      <br />
      <ul className="disc">
        <li>
          <span className="method">200 OK</span> <br />
          <div className="idea">
            - Bravo! You've added your usage example to the pickup line. 🎉 Your
            contribution will help others master the art of pickup lines. Keep
            the creativity flowing! 🚀
          </div>
        </li>
        <li>
          <span className="method">404 Not Found</span> <br />
          <div className="idea">
            - Oops, the pickup line with that specific ID seems to have vanished
            into thin air. 🔮
          </div>
        </li>
        <li>
          <span className="method">500 Internal Server Error</span>
          <br />
          <div className="idea">
            Our server might be taking a coffee break. No worries; it'll be back
            in action soon! ☕
          </div>
        </li>
      </ul>
      <div className="dbline"></div>
      <div className="line"></div>
      <span className="special">
        These endpoints are all about having fun with pickup lines! Rate them,
        share your thoughts, and contribute your own examples to spread the
        laughter and charm. Keep it light, creative, and don't forget to have a
        blast! 🎉😄🚀
      </span>
    </section>
  );
};

export default Usage;
